import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom';
export function RestaurantSection() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-10%', '10%']);
  return <section ref={ref} className="py-32 px-4 w-full bg-base relative overflow-hidden" data-id="element-270">
      {/* Amber/Gold Glows */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gold/5 blur-[150px] rounded-full pointer-events-none" data-id="element-271" />

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center relative z-10" data-id="element-272">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-start order-2 lg:order-1" data-id="element-273">
          <h2 className="text-5xl md:text-6xl font-heading font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-gold" data-id="element-274">
            Die Auszeit, die Sie verdienen
          </h2>
          <p className="text-xl text-gray-500 mb-8 font-body leading-relaxed" data-id="element-275">
            Frische Zutaten, regionale Spezialitäten und ein Ambiente, das zum
            Verweilen einlädt. Genießen Sie unsere vielfältige Küche von früh
            bis spät.
          </p>

          <div className="glass-card p-6 rounded-2xl mb-10 w-full border-gold/20" data-id="element-276">
            <h4 className="text-gold font-semibold mb-2" data-id="element-277">Öffnungszeiten</h4>
            <p className="text-gray-700" data-id="element-278">Montag – Sonntag: 06:00 – 22:00 Uhr</p>
            <div className="h-px w-full bg-gray-200 my-4" data-id="element-279" />
            <p className="text-gray-500 text-sm" data-id="element-280">
              Warme Küche durchgehend bis 21:30 Uhr
            </p>
          </div>

          <motion.div whileHover={{
          scale: 1.05,
          boxShadow: '0 0 30px rgba(245, 158, 11, 0.4)'
        }} whileTap={{
          scale: 0.95
        }} className="inline-block rounded-xl" data-id="element-281">
            <Link to="/restaurant" className="inline-block px-8 py-4 rounded-xl bg-gold text-white font-semibold text-lg transition-colors" data-id="element-282">
              Speisekarte ansehen
            </Link>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative aspect-[4/5] rounded-[2.5rem] overflow-hidden order-1 lg:order-2" data-id="element-283">
          <motion.div style={{
          y
        }} className="absolute -inset-10" data-id="element-284">
            <img src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=900&q=80" alt="Auszeit Restaurant im Euro Rastpark Himmelkron" className="w-full h-full object-cover" data-id="element-285" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/20" data-id="element-286" />
            <div className="absolute inset-0 bg-gold/5 mix-blend-overlay" data-id="element-287" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}